import sum from 'lodash/sum';

const calcTotalChargers = ({chargerSets}) =>
  sum(chargerSets.map((set) => set.charger.ports * set.chargerCount));

export default calcTotalChargers;
